import React, { Fragment, useState } from 'react'
import { Button, OverlayTrigger, Table, Tooltip, Card } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp, faPrint } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'
import { printPaymentReceipt } from '../Templates/PrintableReceipt'
import { formatMoney } from '../../utils/string.utils'
import { formasDePagamento, statusParcelas } from '../../constants/common.constants'
import FinanceiroService from '../../services/financeiro.service'
import OrtodontiaService from '../../services/ortodontia.service'

const scrollWrapProps = {
  className: 'table-responsive plano-tratamento-detalhe-scroll',
  style: { WebkitOverflowScrolling: 'touch' },
}

export default function PagamentosRealizados({
  setIsLoading,
  pagamentosRealizados,
  paciente,
  getPagamentosRealizados,
}) {
  const [isOpen, setIsOpen] = useState('')

  const handlePrint = async (pagamento) => {
    setIsLoading(true)
    printPaymentReceipt({
      ...pagamento,
      nomeContratante: paciente.nome,
      nomeColaborador: typeof pagamento.nomeColaborador !== 'undefined' && pagamento.nomeColaborador !== null ? pagamento.nomeColaborador : '',
      parcelasPayload: pagamento.parcelas,
      formaPagamento: !!pagamento.formaPagamento ? pagamento.formaPagamento : formasDePagamento.DINHEIRO.label,
    })
    if (pagamento.pagamentoOrtodontia) {
      await OrtodontiaService.marcarImpresso(pagamento.id)
      await getPagamentosRealizados()
    } else {
      await FinanceiroService.marcarImpresso(pagamento.id)
      await getPagamentosRealizados()
    }
    setIsLoading(false)
  }

  const handleOpen = (codigoValidacao) => {
    isOpen === codigoValidacao ? setIsOpen('') : setIsOpen(codigoValidacao)
  }

  const getStatusParcelaLabel = (parcela) => {
    const statusObj = Object.values(statusParcelas).find((status) => status.value === parcela.status)
    return statusObj ? statusObj.label : '--'
  }

  const groupedPayments = pagamentosRealizados.reduce((acc, pagamento) => {
    const validationKey = pagamento.codigoValidacao || 'Sem validação'

    if (!acc[validationKey]) acc[validationKey] = []

    acc[validationKey].push(pagamento)
    return acc
  }, {})

  const renderDetalhePagamento = (parcela, idx) => (
    <Fragment key={idx}>
      <div {...scrollWrapProps}>
        <Table className='mb-0' style={{ minWidth: '420px' }}>
          <thead>
            <tr className='text-center' style={{ backgroundColor: 'white' }}>
              <th>Forma de Pagamento</th>
              <th>Valor Pago</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr className='text-center' style={{ backgroundColor: 'white' }}>
              <td>{parcela.formaPagamento ?? '-'}</td>
              <td>{parcela.valorPago ? formatMoney(parcela.valorPago) : 'Pagamento cancelado'}</td>
              <td>
                {!!parcela.valorPago && (
                  <OverlayTrigger trigger='hover' placement='top' overlay={<Tooltip>Imprimir Comprovante</Tooltip>}>
                    <Button onClick={() => handlePrint(parcela)} variant='primary' size='sm'>
                      <FontAwesomeIcon icon={faPrint} />
                    </Button>
                  </OverlayTrigger>
                )}
              </td>
            </tr>
            <tr>
              <td colSpan={3} className='p-0 border-0'>
                <div {...scrollWrapProps}>
                  <Table className='mb-0' style={{ minWidth: '720px' }}>
                    <thead>
                      <tr className='text-center' style={{ backgroundColor: 'white' }}>
                        <th>Vencimento</th>
                        <th>Parcela</th>
                        <th>Desconto</th>
                        <th>Juros</th>
                        <th>Multa</th>
                        <th>Status</th>
                        <th>Valor Pago</th>
                      </tr>
                    </thead>
                    <tbody>
                      {parcela.parcelas.map((p, pIdx) => (
                        <tr key={pIdx} className='text-center' style={{ backgroundColor: 'white' }}>
                          <td>{moment(p.dataVencimento).format('DD/MM/YYYY')}</td>
                          <td>{p.parcela}</td>
                          <td>{p.desconto > 0 ? formatMoney(p.desconto) : '-'}</td>
                          <td>{p.juros > 0 ? formatMoney(p.juros) : '-'}</td>
                          <td>{p.multa > 0 ? formatMoney(p.multa) : '-'}</td>
                          <td>{getStatusParcelaLabel(p)}</td>
                          <td>{p.valorPago ? formatMoney(p.valorPago) : 'Pagamento cancelado'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    </Fragment>
  )

  return (
    <Fragment>
      {pagamentosRealizados && pagamentosRealizados.length > 0 ? (
        <>
          <div className='d-none d-md-block'>
            <div {...scrollWrapProps}>
              <Table className='mt-3 mb-0' bordered style={{ minWidth: '720px' }}>
                <thead>
                  <tr className='text-center'>
                    <th width='150px'>Data</th>
                    <th width='150px'>Validação</th>
                    <th width='150px'>Plano</th>
                    <th>Colaborador</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(groupedPayments).map((codigoValidacao) => {
                    const expand = codigoValidacao === isOpen
                    const grupoPorForma = groupedPayments[codigoValidacao]
                    const primeiroPagamento = grupoPorForma?.[0]

                    return (
                      <Fragment key={codigoValidacao}>
                        <tr className='text-center bg-light'>
                          <td>{moment(primeiroPagamento.dataPagamento).format('DD/MM/YYYY - HH:mm')}</td>
                          <td>{codigoValidacao}</td>
                          <td>{primeiroPagamento.numeroPlano}</td>
                          <td>{primeiroPagamento.nomeColaborador}</td>
                        </tr>
                        <tr>
                          <td colSpan={4}>
                            <FontAwesomeIcon
                              onClick={() => handleOpen(codigoValidacao)}
                              className='ml-auto d-block mb-2 mt-2 text-secondary'
                              style={{ marginRight: '32px', cursor: 'pointer' }}
                              icon={expand ? faChevronUp : faChevronDown}
                            />
                            <div className={expand ? 'd-block' : 'd-none'}>
                              {grupoPorForma.map((parcela, pIndex) => renderDetalhePagamento(parcela, pIndex))}
                            </div>
                          </td>
                        </tr>
                      </Fragment>
                    )
                  })}
                </tbody>
              </Table>
            </div>
          </div>

          <div className='d-md-none'>
            {Object.keys(groupedPayments).map((codigoValidacao) => {
              const expand = codigoValidacao === isOpen
              const grupoPorForma = groupedPayments[codigoValidacao]
              const primeiroPagamento = grupoPorForma?.[0]

              return (
                <Card key={codigoValidacao} className='mb-3 shadow-sm border plano-tratamento-card-mobile'>
                  <Card.Body className='p-3'>
                    <div className='small'>
                      <div className='d-flex justify-content-between py-2 border-bottom'>
                        <span className='text-muted'>Data</span>
                        <span className='text-dark text-right'>
                          {moment(primeiroPagamento.dataPagamento).format('DD/MM/YYYY - HH:mm')}
                        </span>
                      </div>
                      <div className='d-flex justify-content-between py-2 border-bottom'>
                        <span className='text-muted'>Validação</span>
                        <span className='text-dark text-right small'>{codigoValidacao}</span>
                      </div>
                      <div className='d-flex justify-content-between py-2 border-bottom'>
                        <span className='text-muted'>Plano</span>
                        <span className='text-dark'>{primeiroPagamento.numeroPlano}</span>
                      </div>
                      <div className='d-flex justify-content-between py-2 border-bottom'>
                        <span className='text-muted'>Colaborador</span>
                        <span className='text-dark text-right'>{primeiroPagamento.nomeColaborador}</span>
                      </div>
                    </div>
                    <FontAwesomeIcon
                      onClick={() => handleOpen(codigoValidacao)}
                      className='d-block ml-auto mt-2 mb-2 text-secondary'
                      style={{ cursor: 'pointer' }}
                      icon={expand ? faChevronUp : faChevronDown}
                    />
                    <div className={expand ? 'd-block' : 'd-none'}>
                      {grupoPorForma.map((parcela, pIndex) => renderDetalhePagamento(parcela, pIndex))}
                    </div>
                  </Card.Body>
                </Card>
              )
            })}
          </div>
        </>
      ) : (
        <p>Nenhum pagamento realizado.</p>
      )}
    </Fragment>
  )
}
